import React from 'react';
import { Button } from 'react-bootstrap';
import { SendDocumentButtonMessage } from '../../../../../document-table/DocumentTableConstants';
import { TitleFormattedMessage } from '../../../../../titleFormattedMessage';
import styles from './styles.module.scss';

interface SendProps {
  disabled?: boolean;
  onClick: () => void;
}

const UnlockDocumentButton = ({ disabled, onClick }: SendProps) => {
  return (
    <Button className={styles['grant-access-button']} disabled={disabled} onClick={onClick} variant="outline-primary">
      <TitleFormattedMessage
        id="document-wizard-header.action.unlock-document"
        defaultMessage={SendDocumentButtonMessage.UNLOCK_DOCUMENT}
        data-testid="document-wizard-header-unlock-document-action"
      />
    </Button>
  );
};

export default UnlockDocumentButton;
